
import { useState ,useEffect } from "react";
import ButtonContainer from "./buttonContainer";
import SelectCustom from "../../../../component/elements/selectCustom";
import TextFieldCustom from "../../../../component/elements/textfieldCustom";
import { validateForm } from "../../../../utils/formValidation/validation";
import { personalInfoRules } from "../../../../utils/formValidation/validationRules";
import DatePickerCustom from "../../../../component/elements/datePicker/index"
import dayjs from "dayjs";
import { getLatLngFromZip } from "../../../../utils/latLongFetch";
import { useSnackbar } from "../../../../component/SnackbarContext";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function PersonalInformation({ nextHandler, previousHandler, mode ,formValues }) {
  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    email: "",
    birthDate: null,
    gender: "",
    addressLine1: "",
    addressLine2: "",
    landmark: "",
    city: "",
    state: "",
    zip: "",
    latitude: "",
    longitude: "",
  });

  const [formErrors, setFormErrors] = useState({});
   const showSnackbar = useSnackbar();
  useEffect(() => {
    if (formValues && Object.keys(formValues).length > 0) {
      setFormData((prev) => ({
        ...prev,
        ...formValues,
        birthDate:
          formValues.birthDate == null || formValues.birthDate === ""
            ? null
            : typeof formValues.birthDate?.isValid === "function"
              ? formValues.birthDate.isValid()
                ? formValues.birthDate
                : null
              : dayjs(formValues.birthDate).isValid()
                ? dayjs(formValues.birthDate)
                : null,
      }));
    }
  }, [formValues]);

  const handleChange = (field) => (e) => {
    const value = e.target?.value ?? e;
    setFormData((prev) => ({ ...prev, [field]: value }));
    setFormErrors((prev) => ({ ...prev, [field]: "" })); // clear error on change
  };

  const handleSubmit = async () => {
    const errors = validateForm(formData, personalInfoRules);
    setFormErrors(errors);
 
    if (Object.keys(errors).length === 0) { 
       let updatedFormData = { ...formData };
      let latlong = await getLatLngFromZip(formData.zip)
       if (!latlong) {
         showSnackbar("Failed to get location from zip code", "error");
         return;
      }
      updatedFormData.latitude = latlong.latitude;
      updatedFormData.longitude = latlong.longitude;
      if(mode === "edit"){
        updatedFormData ={
          ...updatedFormData,
          ...formValues.address_id,
          ...formValues.latlong_id
        }
      }
      nextHandler(updatedFormData, "personal-info");
    }
  };

  return (
    <>
      <div>
        <div className="shadow-card py-7 px-6 rounded-[16px] grid  grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-1 gap-x-3 items-stretch">
          <TextFieldCustom
            label="Full Name"
            fullWidth
            value={formData.fullName}
            onChange={handleChange("fullName")}
            error={!!formErrors.fullName}
            helperText={formErrors.fullName || " "}
          />

                  <div>
            <PhoneInput
              country={"us"}
              value={formData.mobile}
              onChange={(val) => handleChange("mobile")(val)}
                    inputClass="!w-full !h-[53px] !border !border-[#d1d5db]"
              containerClass="w-full"
            />
            {formErrors.mobile && (
              <div className="text-red-600 text-xs mt-1">{formErrors.mobile}</div>
            )}
          </div>
          {/* <TextFieldCustom
            label="Mobile Number*"
            fullWidth
            value={formData.mobile}
            onChange={handleChange("mobile")}
            error={!!formErrors.mobile}
            helperText={formErrors.mobile || " "}
          /> */}

          <TextFieldCustom
            label="Email*"
            fullWidth
            value={formData.email}
            onChange={handleChange("email")}
            error={!!formErrors.email}
            helperText={formErrors.email || " "}
          />

          <DatePickerCustom
            label="Birth Date*"
            value={formData.birthDate}
            onChange={handleChange("birthDate")}
            error={!!formErrors.birthDate}
            helperText={formErrors.birthDate || " "}
            maxDate={dayjs()}
          />

          <SelectCustom
            label="Gender"
            value={formData.gender}
            onChange={handleChange("gender")}
            options={[
              { value: "male", label: "Male" },
              { value: "female", label: "Female" },
              { value: "other", label: "Other" },
            ]}
            error={!!formErrors.gender}
            helperText={formErrors.gender || " "}
          />

          <TextFieldCustom
            label="Address*"
            fullWidth
            value={formData.addressLine1}
            onChange={handleChange("addressLine1")}
            error={!!formErrors.addressLine1}
            helperText={formErrors.addressLine1 || " "}
          />

          {/* <TextFieldCustom
            label="Area, Street ,Sector, Village*"
            fullWidth
            value={formData.addressLine2}
            onChange={handleChange("addressLine2")}
            error={!!formErrors.addressLine2}
            helperText={formErrors.addressLine2 || " "}
          /> */}

          <TextFieldCustom
            label="Unit"
            fullWidth
            value={formData.landmark}
            onChange={handleChange("landmark")}
            // error={!!formErrors.landmark}
            // helperText={formErrors.landmark || " "}
          />

          <TextFieldCustom
            label="City/Town*"
            fullWidth
            value={formData.city}
            onChange={handleChange("city")}
            error={!!formErrors.city}
            helperText={formErrors.city || " "}
          />

          <TextFieldCustom
            label="State*"
            fullWidth
            value={formData.state}
            onChange={handleChange("state")}
            error={!!formErrors.state}
            helperText={formErrors.state || " "}
          />

          <TextFieldCustom
            label="Zip code*"
            fullWidth
            value={formData.zip}
            onChange={handleChange("zip")}
            error={!!formErrors.zip}
            helperText={formErrors.zip || " "}
          />
        </div>
      </div>

      <ButtonContainer handleNext={handleSubmit} handlePrevious={previousHandler} mode={mode} />
    </>
  );
}

export default PersonalInformation;
